if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
                          setTimeout(()=>{
                             const discountDivs = document.querySelectorAll('div[data-customdiscount-product="true"]');
                              // Get the count
                              const discountDivCount = discountDivs.length;
                              if(discountDivCount>0){
                                matchfound='true';
                              }else{
                                matchfound='false';
                              }
                               toggleButtons();
                              console.log("Count of divs with data-customdiscount-product='true':", discountDivCount);
                              updateTotalRegularPrice(); //FUNCTION CALLED
                          }, 2500); 
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					console.log('Cart Update')
					const event = new Event('cart-updated');
					this.dispatchEvent(event);
                    const discountDivs = document.querySelectorAll('div[data-customdiscount-product="true"]');
                    // Get the count
                    const discountDivCount = discountDivs.length;
                    if(discountDivCount>0){
                      matchfound='true';
                    }else{
                      matchfound='false';
                    }
                    toggleButtons();
                    updateTotalRegularPrice();
                    // initializeStoreCredit();
                    // setTimeout(()=>{
                    //   updateTotalRegularPrice(); //FUNCTION CALLED
                    // }, 2500);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
                
			}, 50);
            setTimeout(()=>{
                updateTotalRegularPrice(); //FUNCTION CALLED
            }, 2500);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart
function initializeStoreCredit() {
  console.log('initialize Store Credit')
  const storeCreditInput = document.getElementById('store-credit-amount');
  
  // const availableBalance = parseFloat(storeCreditInput.dataset.maxValue) || 0;
  // const cartTotal = parseFloat(storeCreditInput.dataset.totalValue) || 0;
  const availableBalance = storeCreditInput ? parseFloat(storeCreditInput.dataset.maxValue) || 0 : 0;
  const cartTotal = storeCreditInput ? parseFloat(storeCreditInput.dataset.totalValue) || 0 : 0;

  // Set the initial value based on available balance and cart total
  const smallestValue = Math.min(availableBalance, cartTotal);
  if(storeCreditInput){
    storeCreditInput.value = smallestValue.toFixed(2);
  }
  
   // Trigger the input event programmatically
  if(document.querySelector('.store-credit-icon')){
  document.querySelector('.store-credit-icon').addEventListener('click', function() {
      const storeCreditInput = document.getElementById('store-credit-amount');
      const storeCreditInput1 = storeCreditInput.getAttribute('data-min-value');
      storeCreditInput.value = storeCreditInput1;
      window.updateRemainingBalance();
    })
  }
  if(storeCreditInput){
  storeCreditInput.addEventListener('input', updateRemainingBalance);
  storeCreditInput.addEventListener('input', toggleButtons);
  document.getElementById('apply-credit-btn-cart').addEventListener('click',manageCheckoutWithStoreCredit);
    if (typeof window.updateRemainingBalance === 'function') {

    window.updateRemainingBalance();

  }
  }
  
  
  if (typeof window.toggleButtons === 'function') {

    window.toggleButtons();

  }
  // Add an event listener for changes to store credit input
}

if ( ! window.refreshCart ) {
    console.log('Cart Refresh')
	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			// initializeStoreCredit();
            updateTotalRegularPrice();
            // setTimeout(()=>{
            //     updateTotalRegularPrice(); //FUNCTION CALLED
            // }, 2500);     
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}


// function updateTotalRegularPrice() {
//     console.log('function worked on change cart..');
//     let totalRegularPrice = 0;
//     document.querySelectorAll(".cart-page-total strong, .cart-drawer-page strong").forEach(item => {
//         console.log('item--',item);
//         let priceText = item.textContent.replace(/[^0-9.]/g, "");
//         let price = parseFloat(priceText);
//         if (!isNaN(price)) {
//             totalRegularPrice += price;
//         }
//     });
//     console.log('totalRegularPrice---',totalRegularPrice);
//     let formattedPrice = `$${totalRegularPrice.toFixed(2)}`;
//     let subtotalElement = document.querySelector(".totals__total-value");
//     if (subtotalElement) {
//         subtotalElement.textContent = `$${totalRegularPrice.toFixed(2)}`;
//     }
//     let totalElement = document.querySelector("#remaining_amount");
//     if (totalElement) {
//         totalElement.textContent = `$${totalRegularPrice.toFixed(2)}`;
//     }
//       // Update store credit input field
//     let storeCreditInput = document.querySelector("#store-credit-amount");
//     if (storeCreditInput) {
//         let updatedValue = totalRegularPrice.toFixed(2);
//         storeCreditInput.value = updatedValue;
//         storeCreditInput.setAttribute("data-min-value", updatedValue);
//         storeCreditInput.setAttribute("data-alert-value", updatedValue);
//         storeCreditInput.setAttribute("data-total-value", updatedValue);
//         storeCreditInput.setAttribute("data-max-value", updatedValue);
//         console.log('Updated store credit input values.');
        
//     }
//    // Update cart total in header
//     let cartTotalElement = document.querySelector("[data-header-cart-total]");
//     if (cartTotalElement) {
//         cartTotalElement.textContent = formattedPrice;
//     }

//     initializeStoreCredit();
  
// }

function updateTotalRegularPrice() {
    console.log('function worked on change cart..');
    let totalRegularPrice = 0;
    let currencySymbol = detectCurrencySymbol();
    let isEuro = currencySymbol === "€";

    document.querySelectorAll(".cart-page-total strong, .cart-drawer-page strong").forEach(item => {
        let priceText = item.textContent.replace(/[^0-9,.-]/g, "").replace(",", ".");
        let price = parseFloat(priceText);
        if (!isNaN(price)) {
            totalRegularPrice += price;
        }
    });

    console.log('totalRegularPrice---', totalRegularPrice);

    let formattedPrice = isEuro 
        ? `${currencySymbol}${totalRegularPrice.toFixed(2).replace(".", ",")}` 
        : `${currencySymbol}${totalRegularPrice.toFixed(2)}`;

    let subtotalElement = document.querySelector(".totals__total-value");
    if (subtotalElement) {
        subtotalElement.textContent = formattedPrice;
    }

    let totalElement = document.querySelector("#remaining_amount");
    if (totalElement) {
        totalElement.textContent = formattedPrice;
    }

    let storeCreditInput = document.querySelector("#store-credit-amount");
    let availableDiv = document.querySelector(".available-div");

    if (storeCreditInput && availableDiv) {
        // 🔒 Preserve value from available-div only
        let availableText = availableDiv.textContent.trim();
        let availableNumeric = parseFloat(availableText.replace(/[^0-9.]/g, '')) || 0;
        let updatedValue = availableNumeric.toFixed(2);

        // Only set attributes, not .value
        storeCreditInput.setAttribute("data-min-value", updatedValue);
        storeCreditInput.setAttribute("data-alert-value", updatedValue);
        storeCreditInput.setAttribute("data-total-value", totalRegularPrice.toFixed(2)); // Cart total
        storeCreditInput.setAttribute("data-max-value", updatedValue);

        console.log('Preserved store credit input value and updated data-* attributes.');
    }

    let cartTotalElement = document.querySelector("[data-header-cart-total]");
    if (cartTotalElement) {
        cartTotalElement.textContent = formattedPrice;
    }

    initializeStoreCredit(); // Only if this doesn't overwrite input.value
}


function detectCurrencySymbol() {
    let priceElement = document.querySelector(".cart-page-total strong, .cart-drawer-page strong");
    if (priceElement) {
        let match = priceElement.textContent.match(/[\p{Sc}]/u);
        return match ? match[0] : "$";
    }
    return "$";
}
function toggleButtons() {
    const storeCreditInput = document.getElementById('store-credit-amount');
    const checkoutButton = document.getElementById('checkout');
    const applyCreditButton = document.getElementById('apply-credit-btn-cart');
    const applyDiscountButton = document.getElementById('apply-discount-btn-cart');
    const creditAmount = storeCreditInput ? parseFloat(storeCreditInput.value) || 0 : 0;
    console.log('matchfound',matchfound);
    if (creditAmount > 0) {
        console.log('if run..');
        if (checkoutButton) {
            checkoutButton.style.display = 'none';
        }
        applyDiscountButton.style.display='none';
        applyCreditButton.style.display = 'block';
    }else if(matchfound && matchfound=='true'){
        if (checkoutButton) {
            checkoutButton.style.display = 'none';
        }
        applyDiscountButton.style.display='block';
        applyCreditButton.style.display = 'none';
    } else {
        console.log('else run..');
        if (checkoutButton) {
            checkoutButton.style.display = 'block';
        }
        applyDiscountButton.style.display='none';
        applyCreditButton.style.display = 'none';
    }
}
